import { render, staticRenderFns } from "./LogRequest.vue?vue&type=template&id=fca0f260"
import script from "./LogRequest.vue?vue&type=script&lang=js"
export * from "./LogRequest.vue?vue&type=script&lang=js"
import style0 from "./LogRequest.vue?vue&type=style&index=0&id=fca0f260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports